module.exports = __webpack_public_path__ + "assets/home-table-mini.761cafe4.svg";